// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__Xnxl3","rotation":"styles_rotation__G9tLi","loaderWrapper":"styles_loaderWrapper__iElIU"};